import { createBrowserRouter } from 'react-router-dom'

// Public pages
import StoryverseLanding from '@/pages/LandingPage'
import { LoginPage, OnboardingPage, RegisterPage } from '@/features/auth'


// Dashboard
import { DashboardPage } from '@/features/dashboard'


// Workspace
import { WorkspacePage, WorkspaceNotFound } from '@/features/workspace'


// Feature pages
import { StoryboardPage } from '@/features/storyboard'
import { ShotListPage } from '@/features/shotlist'
import ScreenplayPage from '@/features/screenplay/pages/ScreenplayPage'
import AddScreenPlay from '@/features/screenplay/pages/AddScreenPlay'
import StoryPage from '@/features/story/pages/StoryPage'
import AddStoryPage from '@/features/story/pages/AddStoryPage'
import V2SPage from '@/pages/V2SPage'
import CharacterPage from '@/features/characters/pages/CharacterPage'
import CharacterDetailPage from '@/features/characters/pages/CharacterDetailPage'

import PricingPage from '@/features/subscription/pages/PricingPage'
import { AuthGuard } from '@/features/auth'
import { Outlet } from 'react-router-dom'
import { ProjectProvider } from './core/project/components/ProjectProvider'
import AccountPage from './features/account/pages/AccountPage'

export const router = createBrowserRouter([
    // Public routes
    {
        path: '/',
        element: <StoryverseLanding />,
    },
    {
        path: '/login',
        element: <LoginPage />,
    },
    {
        path: '/register',
        element: <RegisterPage />,
    },

    // Protected Routes
    {
        element: (
            <AuthGuard>
                <Outlet />
            </AuthGuard>
        ),
        children: [
            // Dashboard
            {
                path: '/dashboard',
                element: <DashboardPage />,
            },
            {
                path: '/account',
                element: <AccountPage />,
            },
            {
                path: '/pricing',
                element: <PricingPage />,
            },
            {
                path: '/onboarding',
                element: <OnboardingPage />,
            },

            // Workspace
            {
                element: <ProjectProvider />,
                children: [
                    {
                        path: '/workspace-not-found',
                        element: <WorkspaceNotFound />,
                    },
                    {
                        path: '/workspace/:project_id',
                        element: <WorkspacePage />,
                    },

                    // Workspace modules
                    {
                        path: '/workspace/:project_id/story',
                        element: <StoryPage />,
                    },
                    {
                        path: '/workspace/:project_id/story/add',
                        element: <AddStoryPage />,
                    },
                    {
                        path: '/workspace/:project_id/screenplay',
                        element: <ScreenplayPage />,
                    },
                    {
                        path: '/workspace/:project_id/screenplay/add',
                        element: <AddScreenPlay />,
                    },
                    {
                        path: '/workspace/:project_id/screenplay/v2s',
                        element: <V2SPage />,
                    },
                    {
                        path: '/workspace/:project_id/storyboard',
                        element: <StoryboardPage />,
                    },
                    {
                        path: '/workspace/:project_id/shotlist',
                        element: <ShotListPage />,
                    },
                    {
                        path: '/workspace/:project_id/characters',
                        element: <CharacterPage />,
                    },
                    {
                        path: '/workspace/:project_id/characters/:character_id',
                        element: <CharacterDetailPage />,
                    },
                ]
            },
        ],
    },
])
